const solidTagModifierMap = {
    music: ['CD', 'MUSIC'],
    video: ['Blu-ray/DVD', 'Blu-ray', 'DVD'],
    book: ['Book'],
    goods: ['GOODS']
};
const createLimitedTagMap = {
    1: '<p class="p-layout-product__privilegeTag c-text-limitedTag c-text-limitedTag--privilege"><span class="c-text-limitedTag__text">きゃにめ特典</span></p>',
    2: '<p class="p-layout-product__privilegeTag c-text-limitedTag c-text-limitedTag--handling"><span class="c-text-limitedTag__text">きゃにめ限定商品</span></p>',
    3: '<p class="p-layout-product__privilegeTag c-text-limitedTag c-text-limitedTag--funclub"><span class="c-text-limitedTag__text">ファンクラブ会員限定</span></p>'
};

/**
 * カテゴリに合ったタグのmodifierを取得
 * @param  {String} category カテゴリ名
 * @return {String}          modifier
 */
const getTagModifier = (category) => {
    let solidTagModifier = '';

    for (const modifier of Object.keys(solidTagModifierMap)) {
        // map内にの配列に一致するカテゴリが存在する場合
        if (solidTagModifierMap[modifier].includes(category)) {
            solidTagModifier = modifier;

            break;
        }
    }

    return `--${solidTagModifier}`;
};

/**
 * 限定特典タグの取得
 * @param  {String} limitedTypeNumString 限定特典判別用の文字列型の数値
 * @return {String}                      限定特典のマークアップ
 */
const getLimitedTag = (limitedTypeNumString) => {
    // map内にぞんざいしない場合は空の文字列を返却
    if (!createLimitedTagMap.hasOwnProperty(limitedTypeNumString)) {
        return '';
    }

    return createLimitedTagMap[limitedTypeNumString];
};

export {getTagModifier, getLimitedTag};
